import { render, staticRenderFns } from "./ztSlider.vue?vue&type=template&id=12a4cdce&scoped=true&"
import script from "./ztSlider.vue?vue&type=script&lang=js&"
export * from "./ztSlider.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/styles/components/ztSlider.css?vue&type=style&index=0&id=12a4cdce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4cdce",
  null
  
)

export default component.exports